import { SyntheticEvent } from 'react';

export const COMING_SOON_IMAGE = '/public/mock/images/coming_soon.svg';
export const COMING_SOON_ICON_IMAGE = '/public/mock/images/coming_soon_icon.svg';

export const setDefaultSrc = (event: SyntheticEvent<HTMLImageElement, Event>): void => {
    event.currentTarget.src = COMING_SOON_IMAGE;
};
